/*
 * @Author: wuqinfa
 * @Date: 2024-02-19 15:48:53
 * @LastEditors: wuqinfa
 * @Description: 
 */
import * as API from '@/services/leads';

export default {
  namespace: 'leads',
  state: {
    schoolQueryList: [],
    scopeSchoolList: [],
    remainingCount: 0, // 获取机构当天剩余撞库数
    notSubmitCount: 0, // 获取当前待确认入库leads数
  },
  effects: {
    *getPhone({ payload }: any, { call, put }: any): any {
      return yield call(API.getPhone, payload);
    },

    *orgLeadsPage({ payload }: any, { call, put }: any): any {
      const res = yield call(API.orgLeadsPage, payload);

      const {
        records = [],
        current = 1,
        size = 10,
        total = 0,
      } = res.data || {};

      // ProTable 的 request 属性，需要返回特定数据结构的 Promise 对象
      return {
        data: records,
        total,
        success: true,
        page: current,
        pageSize: size,
      };
    },

    *orgLeadsSubmit({ payload }: any, { call, put }: any): any {
      return yield call(API.orgLeadsSubmit, payload);
    },
    
    *orgLeadsRemove({ payload }: any, { call, put }: any): any {
      return yield call(API.orgLeadsRemove, payload);
    },
    
    *schoolQuery({ payload }: any, { call, put }: any): any {
      const res = yield call(API.schoolQuery, payload);

      yield put({
        type: '_setState',
        payload: {
          schoolQueryList: res.data || [],
        }
      });
      
      return res;
    },

    *remainingCount({ payload }: any, { call, put }: any): any {
      const res = yield call(API.remainingCount, payload);

      yield put({
        type: '_setState',
        payload: {
          remainingCount: res.data || 0,
        }
      });
      
      return res;
    },

    *importImpact({ payload }: any, { call, put }: any): any {
      return yield call(API.importImpact, payload);
    },
    
    *importPhone({ payload }: any, { call, put }: any): any {
      return yield call(API.importPhone, payload);
    },

    *importSurvey({ payload }: any, { call, put }: any): any {
      return yield call(API.importSurvey, payload);
    },
    
    *batchSubmit({ payload }: any, { call, put }: any): any {
      return yield call(API.batchSubmit, payload);
    },
    
    *notSubmitCount({ payload }: any, { call, put }: any): any {
      const res = yield call(API.notSubmitCount, payload);

      yield put({
        type: '_setState',
        payload: {
          notSubmitCount: res.data || 0,
        }
      });
      
      return res;
    },

    *sendSmsCode({ payload }: any, { call, put }: any): any {
      return yield call(API.sendSmsCode, payload);
    },

    *dataExport({ payload }: any, { call, put }: any): any {
      return yield call(API.dataExport, payload);
    },

    *getScopeSchool({ payload }: any, { call, put }: any): any {
      const res = yield call(API.getScopeSchool, payload);
      yield put({
        type: '_setState',
        payload: {
          scopeSchoolList: res.data
        },
      });
      return res;
    },
  },
  reducers: {
    _setState(state: any, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};